import { jsx as l, jsxs as p } from "react/jsx-runtime";
import { Tooltip as m } from "@systemeio/ui";
import { useEditorState as T } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as N } from "react";
import { twMerge as i } from "tailwind-merge";
import { ToolbarButton as r } from "../../components/content-controls/toolbar-button.mjs";
import { TOOLTIP_STYLES as u, getToolbarIconClassName as b } from "../../constants/default-styles.mjs";
import d from "../../icons/undo-icon.mjs";
import { getShortcut as f, rawShortcuts as h } from "../../utils/get-shortcuts.mjs";
import { useTranslation as R } from "../../i18n.mjs";
const w = (s) => {
  const { t: e } = R(), n = T({
    editor: s,
    selector: ({ editor: o }) => ({
      isEditable: (o == null ? void 0 : o.options.editable) ?? !1,
      canUndo: (o == null ? void 0 : o.can().undo()) ?? !1,
      canRedo: (o == null ? void 0 : o.can().redo()) ?? !1
    })
  }), a = !(n != null && n.isEditable) || !(n != null && n.canUndo), c = !(n != null && n.isEditable) || !(n != null && n.canRedo);
  return N(() => [
    {
      toolbarRender: /* @__PURE__ */ l(
        m,
        {
          disabled: a,
          label: `${e("undo")} (${f(h.history.undo)})`,
          ...u,
          children: /* @__PURE__ */ l(
            r,
            {
              onClick: () => s == null ? void 0 : s.chain().focus().undo().run(),
              disabled: a,
              children: /* @__PURE__ */ l(d, { className: b(a) })
            }
          )
        },
        "undo"
      ),
      tooltipRender: /* @__PURE__ */ l(
        m,
        {
          disabled: a,
          label: f(h.history.undo),
          ...u,
          children: /* @__PURE__ */ p(
            r,
            {
              onClick: () => s == null ? void 0 : s.chain().focus().undo().run(),
              className: "flex gap-1",
              disabled: a,
              children: [
                /* @__PURE__ */ l(d, { className: b(a) }),
                e("undo")
              ]
            }
          )
        },
        "undo"
      )
    },
    {
      toolbarRender: /* @__PURE__ */ l(
        m,
        {
          disabled: c,
          label: `${e("redo")} (${f(h.history.redo)})`,
          ...u,
          children: /* @__PURE__ */ l(
            r,
            {
              onClick: () => s == null ? void 0 : s.chain().focus().redo().run(),
              disabled: c,
              children: /* @__PURE__ */ l(
                d,
                {
                  className: i(b(c), "rotate-180")
                }
              )
            }
          )
        },
        "redo"
      ),
      tooltipRender: /* @__PURE__ */ l(
        m,
        {
          disabled: c,
          label: f(h.history.redo),
          ...u,
          children: /* @__PURE__ */ p(
            r,
            {
              onClick: () => s == null ? void 0 : s.chain().focus().redo().run(),
              className: "flex gap-1",
              disabled: c,
              children: [
                /* @__PURE__ */ l(
                  d,
                  {
                    className: i(b(c), "rotate-180")
                  }
                ),
                e("redo")
              ]
            }
          )
        },
        "redo"
      )
    }
  ], [s, c, a, e]);
};
export {
  w as useHistoryExtensionToolbar
};
